import React from "react";
import styles from "./prompts.module.css";

type Prompt = {
  title: string;
  description?: string;
};

type PromptSectionsProps = {
  prompts: Prompt[];
  handleClickPrompt?: (prompt: Prompt) => void;
};

const PromptSections = ({
  prompts,
  handleClickPrompt,
}: PromptSectionsProps) => {
  return (
    <div className={styles.promptSection}>
      <div className={styles.promptsContainer}>
        {prompts.map((prompt) => (
          <div
            key={prompt.title}
            className={styles.promptCard}
            onClick={() => handleClickPrompt?.(prompt)}
          >
            <div className={styles.title}>{prompt.title}</div>
            {prompt.description && (
              <div className={styles.description}>{prompt.description}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
export default PromptSections;
